import { initialFilters, periods } from "../constants";

export const customerRankingColumns = [
  {
    label: "#",
    id: "position",
    align: "center",
    width: 16,
    format: (item) => `${item}º`,
  },
  {
    label: "Empresa",
    id: "company",
    style: {
      whiteSpace: "nowrap",
    },
    format: (item) => item ?? "Sem descrição",
  },
  {
    label: "Cliente",
    id: "description",
    style: {
      whiteSpace: "nowrap",
    },
    format: (item) => item ?? "Sem descrição",
  },
  {
    label: "Valor Original (R$)",
    id: "originalAmount",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Acréscimos (R$)",
    id: "increase",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Descontos (R$)",
    id: "discount",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Valor a Líquido (R$)",
    id: "netValue",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
  {
    label: "Total Recebido (R$)",
    id: "finishedAmount",
    align: "right",
    minWidth: 125,
    format: (item) => {
      return `${(item ?? 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 5,
      })}`;
    },
  },
];

export const situations = [
  { desc: "Abertos", id: "open", checked: true },
  { desc: "Vencidos", id: "expired", checked: false },
  { desc: "Recebidos", id: "received", checked: false },
];

export const origins = [
  { desc: "NFe", id: "NFe", checked: false },
  { desc: "Contrato", id: "contra", checked: false },
  { desc: "NF", id: "nf", checked: false },
  { desc: "Venda", id: "venda", checked: false },
  { desc: "Crédito", id: "cred", checked: false },
  { desc: "Manual", id: "manual", checked: false },
];

export const rankCriterias = {
  "Valor Original": "originalAmount",
  "Valor Líquido": "netValue",
  "Valor Recebido": "finishedAmount",
};

export const dateFilters = {
  Emissão: "emission",
  Vencimento: "expiration",
  Recebimento: "receipt",
  Crédito: "credit",
};

export const drawersKey = {
  origin: "origin",
  situation: "situation",
};

export const sortDirections = {
  asc: "asc",
  desc: "desc",
};

export const customerRankingInitialFilters = {
  multicompany: initialFilters.multicompany,
  period: periods["Este mês"],
  startDate: initialFilters.startDate,
  endDate: initialFilters.endDate,
  dateFilter: dateFilters.Emissão,
  sortDirection: sortDirections.asc,
  quickStatus: situations[0].id,
  rankCriteria: rankCriterias["Valor Original"],
};

export const dateLabels = {
  expiration: `vencidos`,
  emission: "emitidos",
  payment: "pagos",
};

export const emptyDescription = {
  date: "Sem data",
  name: "Sem descrição",
  situation: "Sem situação",
};
